export default {
  restricted: {
    title: "Restricted Access",
    description: "You must be logged in to access this page.",
    login: "Login"
  },
  denied: {
    title: "Access Denied",
    description: "You don't have the necessary permissions to access this page.",
    back: "Back to Home"
  },
  expired: {
    title: "Session Expired",
    description: "Your session has expired. Please log in again.",
    login: "Log in again"
  },
  invitation: {
    title: "Invitation Required",
    description: "You need an invitation to access this resource.",
    contact: "Contact the administrator to get an invitation."
  },
  subscriptionRequired: {
    title: "Subscription Required",
    description: "This feature requires an active subscription.",
    upgrade: "Upgrade"
  }
};

